module.exports = __webpack_public_path__ + "static/media/close.7c28d033.svg";